<template>
  <div class="page-container">
    <el-card class="card-top" shadow="hover">
      <div class="card-actions">
        <el-button type="primary" icon="el-icon-plus" @click="openAddDialog">新增车辆</el-button>
      </div>
    </el-card>
    <el-card class="card-table" shadow="hover">
      <el-table :data="coaches" border stripe style="width: 100%" size="small" height="600px">
        <el-table-column prop="vehicleType" label="车辆类型" align="center" />
        <!-- <el-table-column prop="model" label="车辆品牌" align="center">
          <template slot-scope="scope">
            {{ scope.row.brand }} - {{ scope.row.model }}
          </template>
        </el-table-column>
        <el-table-column prop="licensePlate" label="车牌号" align="center" />
        <el-table-column prop="year" label="车辆年份" align="center" /> -->
        <el-table-column prop="photoUrl" label="车辆照片" align="center" width="120">
          <template slot-scope="scope">
            <img v-if="scope.row.imageUrl" :src="scope.row.imageUrl" alt="车辆照片" class="table-photo" />
            <span v-else style="color: #ccc;">无</span>
          </template>
        </el-table-column>
        <el-table-column prop="description" label="车辆描述" align="center" />
        <!-- <el-table-column label="操作" align="center" width="160">
          <template slot-scope="scope">
            <el-button type="text" style="color: #409EFF" size="small" @click="editCoach(scope.row)">编辑</el-button>
            <el-button type="text" style="color: #F56C6C" size="small" @click="deleteCoach(scope.row)">删除</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <div class="table-pagination">
        <el-pagination background layout="prev, pager, next" :total="total" :page-size="size" :current-page="page"
          @current-change="handlePageChange" />
      </div>
    </el-card>

    <el-dialog :title="isEdit ? '编辑车辆' : '新增车辆'" :visible.sync="visible" width="420px" :close-on-click-modal="false">
      <el-form :model="form" :rules="rules" ref="formRef" label-width="90px" size="small">
        <el-form-item label="车辆类型" prop="vehicleType">
          <el-input v-model="form.vehicleType" placeholder="请输入车辆类型" size="small" />
        </el-form-item>
        <el-form-item label="车辆品牌" prop="brand">
          <el-input v-model="form.brand" placeholder="请输入车辆品牌" size="small" />
        </el-form-item>
        <el-form-item label="车辆型号" prop="model">
          <el-input v-model="form.model" placeholder="请输入车辆型号" size="small" />
        </el-form-item>
        <el-form-item label="车牌号" prop="licensePlate">
          <el-input v-model="form.licensePlate" placeholder="请输入车牌号" size="small" />
        </el-form-item>
        <el-form-item label="车辆年份" prop="year">
          <el-input v-model="form.year" placeholder="请输入车牌号" size="small" />
        </el-form-item>
        <el-form-item label="车辆描述" prop="description">
          <el-input v-model="form.description" placeholder="请输入车辆描述" size="small" />
        </el-form-item>
        <el-form-item label="车辆照片" prop="imageUrl">
          <!-- 保持原有上传图片逻辑 -->
          <el-upload class="upload-demo" action="" list-type="picture-card" :show-file-list="false"
            :before-upload="handleBeforeUpload" :on-change="file => handleFileChange(file, 'imageUrl')">
            <div v-if="form.imageUrl" class="avatar-wrapper">
              <img :src="form.imageUrl" class="avatar" />
              <i class="el-icon-close close-icon" @click.stop="clearCoachPhoto"></i>
            </div>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'CoachManage',
  data() {
    return {
      coaches: [],
      total: 0,
      page: 1,
      size: 10,
      visible: false,
      isEdit: false,
      form: {
        vehicleType: '',
        brand: '',
        model: '',
        licensePlate: '',
        imageUrl: '',
        description: '',
        year: '',
        imageUrl: '',
      },
      rules: {
        vehicleType: [
          { required: true, message: '请输入车辆类型', trigger: 'blur' }
        ],
        brand: [
          { required: true, message: '请输入车辆品牌', trigger: 'blur' }
        ],
        model: [
          { required: true, message: '请输入车辆型号', trigger: 'blur' }
        ],
        licensePlate: [
          { required: true, message: '请输入车牌号', trigger: 'blur' }
        ],
        year: [
          { required: true, message: '请输入车辆年份', trigger: 'blur' },
        ],
        description: [
          { required: true, message: '请输入车辆描述', trigger: 'blur' }
        ],
        imageUrl: [
          { required: true, message: '请上传车辆照片', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    openAddDialog() {
      this.isEdit = false;
      this.form = {
        vehicleType: '',
        brand: '',
        model: '',
        licensePlate: '',
        imageUrl: '',
        description: '',
        year: '',
        imageUrl: '',
      };
      this.visible = true;
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },
    async editCoach(row) {
      this.isEdit = true;
      this.visible = true;
      try {
        const res = await axios.get(`/api/vehicles/${row.id}`);
        const data = res.data;
        this.form = {
          id: data.id || '',
          vehicleType: data.vehicleType || '',
          brand: data.brand || '',
          model: data.model || '',
          licensePlate: data.licensePlate || '',
          imageUrl: data.imageUrl || '',
          description: data.description || '',
          year: data.year || '',
          imageUrl: data.imageUrl || '',
        };
      } catch (e) {
        this.$message.error('获取车辆详情失败');
      }
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },
    async deleteCoach(row) {
      try {
        await axios.delete(`/api/vehicles/${row.id}`);
        this.$message.success('删除成功');
        this.fetchCoaches();
      } catch (e) {
        this.$message.error('删除失败');
      }
    },
    handleBeforeUpload() {
      // 阻止自动上传
      return false;
    },
    async uploadCoachPhoto(file) {
      const formData = new FormData();
      formData.append('file', file);
      // 代理已配置，直接用 /api/upload/image
      const res = await axios.post('/api/upload/image', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      if (res.data.fileName) {
        return res.data.previewUrl;
      } else {
        this.$message.error(res.data.error);
      }

    },
    async handleFileChange(file, type) {
      this.form[type] = file.raw;
      // 上传图片并获取URL
      try {
        this.form.imageUrl = await this.uploadCoachPhoto(file.raw);
        console.log("🚀 ~ handleFileChange ~  this.form.imageUrl:", this.form.imageUrl)

        // 如果 url 为 undefined（上传失败），不做任何处理，保留原图片
      } catch (e) {
        this.$message.error('图片上传失败');
        // 不清空当前图片，保留原有图片
      }
    },
    clearCoachPhoto() {
      this.form.imageUrl = '';
    },
    async handleSubmit() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return;
        const params = {
          id: this.form.id,
          vehicleType: this.form.vehicleType,
          brand: this.form.brand,
          model: this.form.model,
          licensePlate: this.form.licensePlate,
          imageUrl: this.form.imageUr,
          description: this.form.description,
          year: this.form.year,
          imageUrl: this.form.imageUrl,
        };
        try {
          let nowId = '';
          if (this.isEdit && this.form.id) {
            // 编辑，PUT
           const res = await axios.put(`/api/vehicles/${this.form.id}`, params);
           nowId = res.data.id;
          } else {
            // 新增，POST
            const res = await axios.post('/api/vehicles', params);
            nowId = res.data.id;
          }
          if (nowId) {
            this.$message.success(`${this.isEdit ? '编辑' : '新增'}车辆成功`);
          } else {
            this.$message.error(`${this.isEdit ? '编辑' : '新增'}车辆失败`);
          }
          this.visible = false;
          this.isEdit = false;
          this.form = {
            name: '',
            gender: '',
            phone: '',
            idCard: '',
            imageUrl: '',
          };
          this.page = 1;
          this.fetchCoaches();
        } catch (e) {
          this.$message.error(`${this.isEdit ? '编辑' : '新增'}车辆失败`);
        }
      });
    },
    async fetchCoaches() {
      try {
        const res = await axios.get('/api/vehicles', {
          params: {
            page: this.page,
            size: this.size
          }
        });
        console.log("🚀 ~ fetchCoaches ~ res:", res)
        // 假设后端返回 { data: [...], total: 100 }
        this.coaches = res.data || [];
        this.total = res.data.totalElements || 0;
      } catch (e) {
        this.$message.error('获取教练列表失败');
      }
    },
    handlePageChange(val) {
      this.page = val;
      this.fetchCoaches();
    }
  },
  mounted() {
    this.fetchCoaches();
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  padding: 24px 18px 0 18px;
  background: #f6f8fa;
  min-height: 100%;
}

.card-top {
  margin-bottom: 18px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.card-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.card-table {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.el-table {
  font-size: 15px;
  border-radius: 6px;
  overflow: hidden;
}

.table-pagination {
  margin-top: 18px;
  text-align: right;
}

.upload-demo {
  display: flex;
  flex-direction: column;
}

.avatar-wrapper {
  position: relative;
  display: inline-block;
}

.avatar {
  width: 148px;
  height: 148px;
  display: block;
  object-fit: cover;
  border-radius: 6px;
}

.close-icon {
  position: absolute;
  top: 2px;
  right: 2px;
  color: #fff;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  font-size: 18px;
  cursor: pointer;
  z-index: 2;
  padding: 2px;
  transition: background 0.2s;
}

.close-icon:hover {
  background: rgba(255, 0, 0, 0.7);
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  line-height: 100px;
  text-align: center;
}

.table-photo {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 4px;
}

.dialog-footer {
  text-align: right;
}
</style>